import { useQuery } from "@tanstack/react-query";
import { Collections } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { COLLECTIONS_QUERY_KEY } from "./useCollections";
export const fetchEntityByCollection = async (entityGRNs) => Collections.getStatuses({ entity_grns: entityGRNs });
export const keyFn = (entityGRN) => [COLLECTIONS_QUERY_KEY, "entity", entityGRN];
const useEntityCollections = (entityGRNs, { enabled } = { enabled: true }) => {
  const {
    data,
    refetch,
    isPending: isLoading,
    error
  } = useQuery({
    queryKey: keyFn(entityGRNs),
    queryFn: () => defaultOnError(
      fetchEntityByCollection(entityGRNs),
      "Loading collection by entity failed with status",
      "Could not load collection by entity."
    ),
    notifyOnChangeProps: ["data", "error"],
    enabled
  });
  return {
    data,
    refetch,
    isLoading,
    error
  };
};
export default useEntityCollections;
